module.exports = __webpack_public_path__ + "static/media/cw_logo.a4df091e.svg";